(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["notify-me-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-notify-trigger]');
    if (!trigger) return;

    const dialogEl = document.getElementById('notify-me-dialog');
    if (!dialogEl) return;

    const productTitle = trigger.getAttribute('data-product-title') || '';
    const productUrl = trigger.getAttribute('data-product-url') || '';

    const nameEl = dialogEl.querySelector('[data-notify-product-name]');
    if (nameEl) nameEl.textContent = productTitle;

    const subjectEl = dialogEl.querySelector('[data-notify-subject]');
    if (subjectEl) subjectEl.value = 'Back in stock request: ' + productTitle;

    const bodyEl = dialogEl.querySelector('[data-notify-body]');
    if (bodyEl) {
      bodyEl.value =
        'Please notify this customer when ' + productTitle + ' (' + productUrl + ') is back in stock.';
    }

    dialogEl.showDialog();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    // Mobile companion <select> for button-style variant options
  // (variant-main-picker.liquid). The <select> is a real form control inside
  // <variant-picker>, so its own native "change" event already flows through
  // the component's existing variantChanged/updateSelectedOption logic
  // correctly (it keeps the select's own [selected] attribute in sync and
  // fetches the updated section). The one thing native handling does NOT do
  // is update the hidden desktop <fieldset> radio for the same option, which
  // would otherwise be left checked on its old value. Since
  // variant-picker's selectedOptionsValues getter scans BOTH
  // "select option[selected]" and "fieldset input:checked" across the whole
  // form, a stale radio would report two conflicting values for one option.
  // This capture-phase listener runs before variant-picker's own bubble-phase
  // handler and simply re-checks the matching radio (native radio-group
  // behavior unchecks the old one for us) so state stays consistent.
  document.addEventListener(
    'change',
    (event) => {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement)) return;
      if (!select.closest('.variant-option--mobile-select')) return;

      const picker = select.closest('variant-picker');
      if (!picker) return;

      const chosen = select.options[select.selectedIndex];
      const valueId = chosen && chosen.dataset.optionValueId;
      if (!valueId) return;

      const radio = picker.querySelector(`fieldset input[data-option-value-id="${valueId}"]`);
      if (radio) radio.checked = true;
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
